<div class="pt-3">
  <div class="p-4" *ngIf="!isNewNotificationsEmpty()">
    <div class="mb-3">
      <div class="groups-links">
        <div *ngIf="oldNotifications.length > 0">
          <div class="notifications_title pb-3">Новые уведомления:</div>
          <app-notifications-list
            [notifications]="notifications"></app-notifications-list>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isNewNotificationsEmpty()">
  <span class="p-3">Новых уведомлений нет</span>
</div>

<div class="p-4" *ngIf="!isOldNotificationsEmpty()">
  <div class="mb-3">
    <div class="groups-links">
      <div *ngIf="oldNotifications.length > 0">
        <div class="d-flex justify-content-between mb-2">
          <div class="notifications_title pb-3">Просмотренные уведомления:</div>
          <app-button-with-progress
            (click)="deleteAllNotifications()"
            type="button"
            matColor="warn"
            label="Удалить уведомления"
            [matTooltip]="
              'При нажатии на кнопку удалятся все прочитаные уведомления'
            ">
          </app-button-with-progress>
        </div>
        <app-notifications-list
          [notifications]="oldNotifications"></app-notifications-list>
      </div>
    </div>
  </div>
</div>
